export default __webpack_public_path__ + "static/media/CoffeeBreak.f8c92082.svg";